<section class="px-8">
  <div class="title-t1 my-0 pt-6 primary-text">{{ 'documentTypeRoleConfigs.title' | translate }}</div>

  <div class="pb-10">
    <div class="flex justify-end my-4">
      <app-button-secondary (click)="openModal()">
        {{ 'documentTypeRoleConfigs.add' | translate }}
      </app-button-secondary>
    </div>

    <div *ngIf="dataSource.data.length === 0" class="body-b2 grey-text py-8 text-center">
      {{ 'documentTypeRoleConfigs.noData' | translate }}
    </div>

    <div *ngIf="dataSource.data.length > 0" class="shadow-dark overflow-auto whitespace-nowrap border-tb">
      <table mat-table [dataSource]="dataSource" class="w-full">

        <ng-container matColumnDef="documentType">
          <th mat-header-cell *matHeaderCellDef>{{ 'documentTypeRoleConfigs.documentType' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span class="link" (click)="openModal(element)">{{ 'objects.' + element.documentType | translate }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="issuerTypes">
          <th mat-header-cell *matHeaderCellDef>{{ 'actorDocuments.roles.issuer' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span class="body-b2" *ngIf="element.issuerTypes.length > 0; else dash">
              <ng-container *ngFor="let t of element.issuerTypes; let last = last">{{ 'objects.' + t | translate }}{{ last ? '' : ', ' }}</ng-container>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="receiverTypes">
          <th mat-header-cell *matHeaderCellDef>{{ 'uploadDocuments.receivers' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span class="body-b2" *ngIf="element.receiverTypes.length > 0; else dash">
              <ng-container *ngFor="let t of element.receiverTypes; let last = last">{{ 'objects.' + t | translate }}{{ last ? '' : ', ' }}</ng-container>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="relatedTypes">
          <th mat-header-cell *matHeaderCellDef>{{ 'uploadDocuments.related' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span class="body-b2" *ngIf="element.relatedTypes.length > 0; else dash">
              <ng-container *ngFor="let t of element.relatedTypes; let last = last">{{ 'objects.' + t | translate }}{{ last ? '' : ', ' }}</ng-container>
            </span>
          </td>
        </ng-container>

        <ng-template #dash>—</ng-template>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <app-button-link iconLeft="trash" (click)="delete(element.documentType)" text="{{ 'buttons.delete' | translate }}" [style]="'warn'"></app-button-link>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
</section>
<app-organization-custom-fields></app-organization-custom-fields>
